import React from 'react';
import { formatPhone } from 'v3/utils/formatter';
import Typography from '@mui/material/Typography';
import { Link } from 'react-router-dom';
import Text from 'v3/components/Text';
import moment from 'moment';

export default function RenderTitle({ deal }) {

  const RenderTitle = ({ deal }) => {
    if (deal?.shipping_company_id) {
      return (
        <>
          <Typography>
            Negociação com{' '}
            <Link
              to={`/transportadoras/${deal?.shipping_company_id}`}
              key={deal?.shipping_company_id}
              target="_blank"
            >
              {deal?.shipping_name}
            </Link>
            {' '}
            {`${formatPhone(deal?.carrier_web_phonenumber)}`}
          </Typography>
          <Text>
            {' '}
            Sinalização de interesse: {moment(deal?.created_at).format('DD/MM/YYYY HH:MM')}
          </Text>
        </>
      );
    }
    return (
      <>
        <Typography>
          Motorista:{' '}
          {deal?.person_id ? (
            <Link to={`/motoristas/${deal?.person_id}`} key={deal?.person_id} target="_blank">
              {deal?.driver_name}
            </Link>
          ) : (
            deal?.driver_name
          )}{' '}
          {`${formatPhone(deal?.driver_phone)}`}
        </Typography>
        <Text>
          {' '}
          Sinalização de interesse: {moment(deal?.created_at).format('DD/MM/YYYY HH:MM')}
        </Text>
      </>
    );
  };

  return <RenderTitle deal={deal} />;
}
